import { defineComponent, reactive } from '@vue/composition-api'
import { i18n } from '@/utilities/vue-i18n';
import { alertDialogue, generalError } from '@/functions/system-modal-functions';
import { createPageContext } from "@/components/navbar-box/page-context";
import OtpModal from '@/components/otp/otp-modal.vue';
import { OtpType } from '@/components/otp/otp-types';
import { ModalIconType } from '@/components/system-modals/system-modals';
import {Accounts, validateEmail} from "@noordigitalagency/accounts-ledigajobb";
import {SettingsContext} from "@/utilities/settings-context";

export default defineComponent({
  components: {
    OtpModal
  },

  setup() {

    const accounts = new Accounts(SettingsContext.constants.accountsApiDomainName);

    const settings = reactive({ showOtp: false });

    const model = reactive({ email: '' });

    function otpShow() {

      settings.showOtp = true;
    }

    function otpClose() {

      settings.showOtp = false;
    }

    const otpConfirmed = async (payload: {otpCode: string; password: string}) => {

      try {

        otpClose();

        await accounts.resetPassword(model.email, payload.otpCode, payload.password);

        await alertDialogue(i18n.t('general.success') as string, i18n.t('pages.forgotten-password.reset-success') as string, ModalIconType.success);

        window.location.replace("sign-in");

      } catch (e) {

        await generalError();
      }
    }

    const submit = async () => {

      try {

        await accounts.forgotPassword(model.email);

        otpShow();

      } catch {

        await generalError();
      }
    }

    const pageContext = createPageContext({

      actions: [],

      title: { text: i18n.t('pages.forgotten-password.forgotten') as string },

      breadcrumb: {

        showHome: false,

        segments: []
      }
    });

    return {
      settings,

      model,

      validateEmail,

      submit,

      pageContext,

      OtpType,

      otpClose,

      otpConfirmed
    }
  }
})
